import api from './api';

const comprobanteService = {
  listar: async (filtros = {}) => {
    const { data } = await api.get('/comprobantes', { params: filtros });
    return data.data;
  },
  crear: async (formData) => {
    const { data } = await api.post('/comprobantes', formData);
    return data.data;
  },
  actualizar: async (id, formData) => {
  const { data } = await api.post(`/comprobantes/${id}/actualizar`, formData);
  return data.data;
  },
  crearJson: async (datos) => {
    const datosLimpios = Object.fromEntries(
      Object.entries(datos).filter(([_, v]) => v !== undefined && v !== null && v !== '')
    );
    const { data } = await api.post('/comprobantes', datosLimpios);
    return data.data;
  },
  actualizarJson: async (id, datos) => {
    const { data } = await api.post(`/comprobantes/${id}`, { ...datos, _method: 'PUT' });
    return data.data;
  },
  eliminar: async (id) => {
    await api.delete(`/comprobantes/${id}`);
  },
  cambiarEstado: async (id, estado) => {
    const { data } = await api.patch(`/comprobantes/${id}/estado`, { estado });
    return data;
  },
  listarContador: async () => {
    const { data } = await api.get('/comprobantes-contador');
    return data.data;
  },
};

export default comprobanteService;
